"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotifications = exports.NOTIFICATIONS_KEY = void 0;
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const frontend_infra_snack_1 = require("@forto-dev/frontend-infra-snack");
const usePagination_1 = require("../../../hooks/usePagination");
const Notifications_1 = require("../components/Notifications");
const translations_1 = require("../types/translations");
const useFetchNotifications_1 = require("./useFetchNotifications");
exports.NOTIFICATIONS_KEY = 'notifications';
const useNotifications = (options, selectedId) => {
    const snackService = (0, frontend_infra_snack_1.useSnackService)();
    const { translate, current } = (0, frontend_infra_localisation_1.useI18n)();
    const { page, pageSize, onPageChange, updatePageSize } = (0, usePagination_1.usePagination)({
        pageSize: Notifications_1.DEFAULT_NOTIFICATIONS_PAGE_SIZE,
    });
    const fetchNotifications = (0, useFetchNotifications_1.useFetchNotifications)();
    const notificationResults = (0, frontend_infra_reactquery_1.useQuery)({
        queryKey: [exports.NOTIFICATIONS_KEY, page, pageSize, current, options],
        queryFn: async () => {
            try {
                return await fetchNotifications({
                    ...options,
                    page,
                    pageSize,
                    selectedId,
                });
            }
            catch (e) {
                snackService.showError(translate(translations_1.notificationsListTranslations.loadError));
                return Promise.reject(e);
            }
        },
        placeholderData: frontend_infra_reactquery_1.keepPreviousData,
    });
    const pageCount = notificationResults.isSuccess ? notificationResults.data.total : 0;
    return {
        notificationResults,
        updatePageSize,
        onPageChange,
        page,
        pageSize,
        pageCount,
    };
};
exports.useNotifications = useNotifications;
//# sourceMappingURL=getNotifications.js.map